import { type ReactNode } from "react";

export function WizardLayout({ children }: { children: ReactNode }) {
  return (
    <div className="max-w-[980px] mx-auto px-9 py-8 pb-20">
      {children}
    </div>
  );
}
